import { render } from "./password_reset.vue?vue&type=template&id=0f7f4f90"
import script from "./password_reset.js?vue&type=script&lang=js"
export * from "./password_reset.js?vue&type=script&lang=js"

import "./password_reset.vue?vue&type=style&index=0&id=0f7f4f90&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__